

document.addEventListener('DOMContentLoaded', () => {

  const settings = window.bundleBuilderSettings || {};

  const BUNDLE_SIZE = Number(settings.bundleSize || 5);
  const BUNDLE_DISCOUNT = Number(settings.bundleDiscount || 0);

  const bundleProducts = [];

  const selectedWrap =
    document.getElementById('bundle-selected-products');

  const totalEl =
    document.getElementById('bundle-total-price');

  const countEl =
    document.querySelector('.bundle-count');

  const mainBtn =
    document.querySelector('.bundle-main-btn');
if(!mainBtn) return;
  const sidebar =
    document.querySelector('.bundle-sidebar');
if(window.innerWidth <= 990){

  sidebar?.classList.add(
    'collapsed'
  );

}
  const toggleBtn =
    document.querySelector('.bundle-toggle');

  const section =
    document.querySelector('.premium-bundle-builder');
const bundleGrid =
document.querySelector('.bundle-grid');
  /* =====================================================
     INIT
  ===================================================== */

  if (!selectedWrap) return;

  selectedWrap.setAttribute(
    'data-size',
    BUNDLE_SIZE
  );

  /* =====================================================
     TABS
  ===================================================== */

  document
    .querySelectorAll('.bundle-tab')
    .forEach(tab => {

      tab.addEventListener('click', () => {

        const target =
          tab.dataset.tab;

        document
          .querySelectorAll('.bundle-tab')
          .forEach(item =>
            item.classList.remove('active')
          );

        document
          .querySelectorAll('.bundle-tab-content')
          .forEach(item =>
            item.classList.remove('active')
          );

        tab.classList.add('active');

        document
          .querySelector(
            `[data-tab-content="${target}"]`
          )
          ?.classList.add('active');

      });

    });

  /* =====================================================
     MOBILE DRAWER
  ===================================================== */

 

document
.querySelector('.bundle-sidebar-header')
?.addEventListener('click', () => {

    if(window.innerWidth > 990){
      return;
    }

    sidebar.classList.toggle('expanded');
    sidebar.classList.toggle('collapsed');

});


/* =====================================================
   MOBILE FIXED → INLINE
===================================================== */

function updateMobileBundlePosition(){

  if(
    window.innerWidth > 990 ||
    !sidebar ||
    !bundleGrid ||
    !section
  ){
    return;
  }

  const gridRect =
  bundleGrid.getBoundingClientRect();

  const sectionRect =
  section.getBoundingClientRect();

const firstRowReached =
gridRect.top < 300;

if(!firstRowReached){
  sidebar.classList.remove(
    'mobile-fixed'
  );

  sidebar.classList.add(
    'mobile-inline'
  );

  return;
}

  sidebar.style.display = 'block';

const reachedLastRow =
gridRect.bottom <
window.innerHeight;

  if(reachedLastRow){

    sidebar.classList.remove(
      'mobile-fixed'
    );

    sidebar.classList.add(
      'mobile-inline'
    );

  }else{

    sidebar.classList.add(
      'mobile-fixed'
    
    );
 
    sidebar.classList.remove(
      'mobile-inline'
    );

  }

}
window.addEventListener(
  'scroll',
  updateMobileBundlePosition
);

window.addEventListener(
  'resize',
  updateMobileBundlePosition
);

updateMobileBundlePosition();


  /* =====================================================
     ADD PRODUCT
  ===================================================== */

  document.addEventListener(
    'click',
    event => {

      const btn =
        event.target.closest(
          '.bundle-add-btn'
        );

      if (!btn) return;

      if (
        bundleProducts.length >=
        BUNDLE_SIZE
      ) {
        return;
      }

      const card =
        btn.closest('.bundle-card');

      const variantSelect =
        card.querySelector(
          '.bundle-variant-select'
        );

      let variantId =
        btn.dataset.variantId;

      let price =
        parseInt(
          btn.dataset.price,
          10
        );

      if (variantSelect) {

        const selected =
          variantSelect.options[
            variantSelect.selectedIndex
          ];

        variantId =
          selected.value;

        price =
          parseInt(
            selected.dataset.price,
            10
          );

      }

   if(!settings.allowDuplicates){

const exists =
bundleProducts.find(
item =>
String(item.variantId) ===
String(variantId)
);

if(exists) return;

}

      bundleProducts.push({

        key:
          Date.now() +
          Math.random(),

        variantId,

        image:
          btn.dataset.image,

        title:
          btn.dataset.title,

        price

      });
if(!settings.allowDuplicates){

  btn.textContent = 'Added';

  btn.classList.add('is-added');

}


      updateBundle();

    }
  );

  /* =====================================================
     REMOVE PRODUCT
  ===================================================== */

  document.addEventListener(
    'click',
    event => {

      const removeBtn =
        event.target.closest(
          '.bundle-remove'
        );

      if (!removeBtn) return;

      const key =
        removeBtn.dataset.key;

      const index =
        bundleProducts.findIndex(
          item =>
            String(item.key) ===
            String(key)
        );

      if (index > -1) {

        bundleProducts.splice(
          index,
          1
        );

      }

      updateBundle();

    }
  );

  /* =====================================================
     RENDER CIRCLES
  ===================================================== */

  function renderBundleSlots() {

    let html = '';

    for (
      let i = 0;
      i < BUNDLE_SIZE;
      i++
    ) {

      const isLast =
        i ===
        BUNDLE_SIZE - 1;

      const product =
        bundleProducts[i];

      html += `
      <div class="bundle-slot ${product ? 'has-product' : ''}">

        <div class="
          bundle-slot-discount
          ${
            bundleProducts.length
            >= BUNDLE_SIZE
            ? 'active'
            : ''
          }
        ">
          ${
            isLast
              ? `-${BUNDLE_DISCOUNT}%`
              : ''
          }
        </div>
      `;

      if (product) {

        html += `
          <div class="bundle-thumb">

            <img
              src="${product.image}"
              alt=""
            >

            <button
              class="
                bundle-thumb-remove
                bundle-remove
              "
              data-key="${product.key}"
            >
              ×
            </button>

          </div>
        `;

      } else {

        html += `
          <div
            class="
              bundle-thumb-empty
            "
          ></div>
        `;

      }

      html += `</div>`;

    }

  selectedWrap.innerHTML = html;
selectedWrap.setAttribute(
  'data-size',
  BUNDLE_SIZE
);

  }

  /* =====================================================
     TOTAL
  ===================================================== */

  function updateTotals() {

    let subtotal = 0;

    bundleProducts.forEach(
      item => {

        subtotal += item.price;

      }
    );

    let finalTotal =
      subtotal;

    if (
      bundleProducts.length
      === BUNDLE_SIZE
    ) {

      finalTotal =
        subtotal -
        (
          subtotal *
          BUNDLE_DISCOUNT /
          100
        );

    }

    if (totalEl) {

      totalEl.innerHTML =
        (
          finalTotal / 100
        ).toLocaleString(
          'en-GB',
          {
            style:'currency',
        currency: settings.currency || 'USD'
          }
        );

    }

  }

  /* =====================================================
     COUNT
  ===================================================== */

  function updateCount() {

    if (!countEl) return;

    countEl.textContent =
      bundleProducts.length;

  }

  /* =====================================================
     CTA BUTTON
  ===================================================== */

  function updateButton() {

    const count =
      bundleProducts.length;

    if (
      count < BUNDLE_SIZE
    ) {

      const left =
        BUNDLE_SIZE - count;

      mainBtn.disabled =
        true;

      mainBtn.classList.remove(
        'bundle-ready'
      );

      mainBtn.textContent =
        `Add ${left} More Item${
          left > 1
            ? 's'
            : ''
        }`;

      return;

    }

    mainBtn.disabled =
      false;

    mainBtn.classList.add(
      'bundle-ready'
    );

    mainBtn.textContent =
      `Add Bundle To Cart`;

  }

  /* =====================================================
     DISABLE PRODUCT BUTTONS
  ===================================================== */

  function updateProductButtons() {

    const full =
      bundleProducts.length
      >= BUNDLE_SIZE;

    document
      .querySelectorAll(
        '.bundle-add-btn'
      )
      .forEach(btn => {

        if (full) {

          btn.classList.add(
            'is-disabled'
          );

        } else {

          btn.classList.remove(
            'is-disabled'
          );

        }

      });

  }

  /* =====================================================
     MASTER UPDATE
  ===================================================== */

  function updateBundle() {

    renderBundleSlots();

    updateCount();

    updateTotals();

    updateButton();

    updateProductButtons();

  }

  /* =====================================================
     AJAX CART
  ===================================================== */

  mainBtn?.addEventListener(
    'click',
    async () => {

      if (
        bundleProducts.length
        !== BUNDLE_SIZE
      ) {
        return;
      }

      try {

        mainBtn.classList.add(
          'bundle-loading'
        );

        const items =
          bundleProducts.map(
            item => ({

              id:Number(
                item.variantId
              ),

              quantity:1,

              properties:{

                Bundle:
                  'Bundle Builder',

                Discount:
                  `${BUNDLE_DISCOUNT}%`

              }

            })
          );

        const response =
          await fetch(
            '/cart/add.js',
            {

              method:'POST',

              headers:{
                'Content-Type':
                'application/json'
              },

              body:JSON.stringify({
                items
              })

            }
          );

        if (!response.ok) {

          throw new Error(
            'Unable to add'
          );

        }

        window.location.href =
          '/cart';

      }

      catch(error) {

        console.error(error);

        alert(
          'Unable to add bundle to cart.'
        );

      }

      finally {

        mainBtn.classList.remove(
          'bundle-loading'
        );

      }

    }
  );

  /* =====================================================
     INIT
  ===================================================== */

  updateBundle();

});




